// extracted by mini-css-extract-plugin
export default {"table_contents":"TableContents_table_contents__Oa0xu","heading":"TableContents_heading__GEWE8","active_class":"TableContents_active_class__J4i-H"};